const axios = require("axios");
import { OwlBlog } from "./OwlCrousel";

export const Blog = () => {
  let blogUrl = "https://blog.dimensional.com.br";
  let postsUrl = `${blogUrl}/wp-json/wp/v2/posts?_embed&per_page=6&category=service`;

  let BoxOwl = "";

  axios
    .get(postsUrl)
    .then(function (response) {
      // handle success
      response.data.map((item) => {
        let json_imagem = "";

        if (item._embedded) {
          if (item._embedded["wp:featuredmedia"]) {
            json_imagem =
              item._embedded["wp:featuredmedia"][0].media_details.sizes.medium
                .source_url;
          } else {
            json_imagem =
              "/wp-content/themes/dimensional/images/bg-footer-new.jpg";
          }
          // json_imagem = `${blogUrl}${json_imagem}`;
        }

        let json_title = item.title.rendered;

        item._embedded
          ? json_imagem
          : "/wp-content/themes/dimensional/images/bg-footer-new.jpg";

        let resumo = item.excerpt.rendered;
        let frase = resumo.substr(0, 75);

        if (resumo.length !== 0) {
          frase = frase + " [...]";
        }

        let json_link = item.link;

        BoxOwl += Card(json_imagem, json_title, frase, json_link);
      });

      $(".owl-blog").append(BoxOwl);
      OwlBlog();
    })
    .catch(function (error) {
      console.log(error);
    });
};

const Card = (imagem_de_capa_url, post_title, breve_descricao, post_name) => {
  return `<div class="item">
    <img src="${imagem_de_capa_url}" alt="${imagem_de_capa_url}">
    <div class="conteudo">
      <h2>${post_title}</h2>
      <div>
        ${breve_descricao}
      </div>
      <a class="btn btn-primary" href="${post_name}" target="_blank">veja mais</a>
    </div>
    </div>`;
};



// WEBPACK FOOTER //
// ./scripts/components/Blog.js